module.exports = __webpack_public_path__ + "static/media/AKAEZE summer program.8a4be822.jpg";